import { useSelector } from 'react-redux'
import { SsmlValidationResultsGroup, validationResultsWithErrorSelector } from '../selectors'

export function useValidationResultsWithError(group: SsmlValidationResultsGroup) {
  return useSelector(validationResultsWithErrorSelector(group))
}
